import { MutationTree } from 'vuex'
import * as types from './types';

const getEmailById = function(
    items?: ItemList<mail.EmailMessage>,
    id?: string
): mail.EmailMessage | undefined {
    return items ? items.find((email) => email.id === id) : undefined;
};

const orderBy = function(favorites: ItemList<any>, name: string = 'name') {
    return favorites.sort((a: any, b: any) => {
        if (a[name] < b[name]) {
            return -1;
        }
        if (a[name] > b[name]) {
            return 1;
        }
        return 0;
    });
};

const getFolderById = function(
    folders: ItemList<mail.MailboxFolder>,
    id: string
): mail.MailboxFolder | undefined {
    if (id) {
        for (var i = 0; i < folders.length; i++) {
            const folder = folders[i];
            if (folder.id === id) {
                return folder;
            } else if (folder.hasChildren) {
                const ret = getFolderById(folder.children || [], id);
                if (ret) {
                    return ret;
                }
            }
        }
    }
    return undefined;
};

export default <MutationTree<mail.state.MailState>>{
    [types.EMAIL_SELECT](state, id: string) {
        const idx = state.selections.indexOf(id);
        if (idx < 0) {
            state.selections.push(id);
        } else {
            state.selections.splice(idx, 1);
        }
    },

    [types.EMAIL_SELECT_ALL](state, ids: string[]) {
        if (ids.length === state.selections.length) {
            state.selections = []
        } else {
            state.selections = ids
        }
    },

    [types.EMAIL_SELECT_CLEAR](state) {
        state.selections = []
    },

    [types.EMAIL_CURRENT](state, selection: mail.EmailSelectionInfo) {
        const { id, method, email } = selection;
        let found = email;
        if (!found && state.emails) {
            found = getEmailById(state.emails.items, id);
        }

        if (found) {
            // 선택 항목 중 하나라도 선택이 해제되면 전체선택도 함께 해제 처리
            if (state.selections.includes(found.id)) {
                state.selectAll = false;
            }

            switch (method) {
                case 'none':
                    state.currentEmail = found;
                    //state.selections = [found.id];
                    state.selectionFrom = found.id;
                    // 이메일 하나를 클릭한 경우 전체 선택 상태 해제
                    state.selectAll = false;
                    break;

                case 'ctrl':
                    const idxCtrl = state.selections.indexOf(found.id);
                    if (idxCtrl < 0) {
                        state.selections.push(found.id);
                        state.selectionFrom = found.id;
                    } else {
                        // 선택이 한개 이상일 경우에만 선택 해제(최소한 한개 선택은 유지)
                        if (state.selections.length > 1) {
                            state.selections.splice(idxCtrl, 1);
                        }
                    }
                    break;

                case 'shift':
                    if (state.selectionFrom) {
                        const items = state.emails?.items || [];
                        const idxFrom = items.findIndex(
                            (m) => m.id === state.selectionFrom
                        );
                        const idxTo = items.findIndex(
                            (m) => m.id === selection.id
                        );
                        const addSelections: string[] = [];
                        if (idxFrom < idxTo)
                            for (var i = idxFrom; i <= idxTo; i++) {
                                addSelections.push(items[i].id);
                            }
                        else {
                            for (var i = idxFrom; i >= idxTo; i--) {
                                addSelections.push(items[i].id);
                            }
                        }
                        state.selections = addSelections;
                    }
                    break;

                case 'toggle':
                    const idx = state.selections.indexOf(found.id);
                    if (idx < 0) {
                        state.selections.push(found.id);
                    } else {
                        state.selections.splice(idx, 1);
                    }
                    break;
            }
        }
    },

    [types.FOLDER_LOAD](
        state,
        data: { parentId?: string; listData: PagedItemList<mail.MailboxFolder> }
    ) {
        const { parentId, listData } = data;
        const folder = getFolderById(state.folders.items, parentId || '');
        const applyAddtionalProps = (
            folders: ItemList<mail.MailboxFolder>
        ): ItemList<mail.MailboxFolder> => {
            return orderBy(
                folders.map((folder) => {
                    folder.nodeStatus = null;
                    if (folder.children) {
                        folder.children = applyAddtionalProps(folder.children);
                    }
                    return folder;
                })
            );
        };
        listData.items = applyAddtionalProps(listData.items);
        if (folder) {
            folder.children = listData.items;
        } else {
            state.folders = listData;
        }
    },
}
